import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { BackofficeAccessService } from '../../shared/components/sidebar/sidebar.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-no-access',
  standalone: true,
  template: `
    <main class="no-access">
      <div class="no-access__card">
        <div class="no-access__icon" aria-hidden="true">!</div>
        <p class="no-access__eyebrow">Acceso restringido</p>
        <h1>No tenés módulos habilitados</h1>
        <p class="no-access__message">
          Tu usuario está autenticado, pero todavía no tiene permisos para acceder al portal.
          Contactá al administrador para solicitar acceso.
        </p>
        <button type="button" (click)="logout()">Cerrar sesión</button>
      </div>
    </main>
  `,
  styles: [`
    :host { display: block; min-height: 100vh; }
    .no-access { min-height: 100vh; display: grid; place-items: center; padding: 32px; background: #f4f8fb; color: #16242e; }
    .no-access__card { width: min(100%, 520px); padding: 48px 42px; text-align: center; background: #fff; border: 1px solid #dce6ec; border-radius: 18px; box-shadow: 0 16px 40px rgba(18, 48, 63, .10); }
    .no-access__icon { width: 58px; height: 58px; display: grid; place-items: center; margin: 0 auto 22px; border-radius: 50%; background: #f8e7e4; color: #c0483b; font-size: 30px; font-weight: 800; }
    .no-access__eyebrow { margin: 0 0 8px; color: #c0483b; font-size: 12px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }
    h1 { margin: 0; font-size: 26px; }
    .no-access__message { margin: 14px auto 28px; max-width: 410px; color: #5a6b76; line-height: 1.55; }
    button { min-height: 42px; padding: 0 22px; border: 0; border-radius: 8px; background: #1b86c8; color: #fff; font: inherit; font-weight: 700; cursor: pointer; }
  `],
})
export class NoAccess {
  constructor(
    private auth: AuthService,
    private router: Router,
    private access: BackofficeAccessService,
  ) {
    this.access.loadAccess().pipe(take(1)).subscribe({
      next: (response) => {
        const firstAvailable = [
          ['dashboard', '/'],
          ['clients', '/clientes'],
          ['clients_permissions', '/permisos'],
          ['oppositions', '/oposiciones'],
          ['metrics_and_usage', '/metricas'],
          ['audit', '/auditoria'],
          ['users_and_roles', '/usuarios'],
          ['api_credentials', '/credenciales'],
        ].find(([key]) => response.modules?.[key] === true);

        if (firstAvailable) this.router.navigateByUrl(firstAvailable[1]);
      },
    });
  }

  logout() {
    this.auth.logout().subscribe({
      complete: () => this.router.navigate(['/login']),
      error: () => this.router.navigate(['/login']),
    });
  }
}
